<script lang="ts" setup>
	const props = defineProps<{
		records: (...arg: unknown) => Promise<PaginationContext | null>
		tableOptions?: TableFilterOptions
		recordColumn?: TableColumn
		actionBtnText?: string
		status?: string
		hideDetails?: boolean
		isLoading?: boolean
	}>()

	const emits = defineEmits<{
		(event: 'change', param: RecordSchema): void
	}>()

	// const custodianRecord = computed(() =>
	// 	props.records.map((item, i) => ({
	// 		...item,
	// 		...item.meta,
	// 		to_be_removed: item?.to_be_removed || item?.meta?.to_be_removed,
	// 		id: item.id,
	// 		purchase_id: item?.purchase_id,
	// 		key: i
	// 	}))
	// )

	const {
		policiesTableColumn: { health }
	} = useProducts()

	const healthColumns = computed(() => {
		if (props.hideDetails) {
			return (health as RecordSchema[]).filter(item => item.key !== 'details')
		}
		return health
	})

	const getStaff = (arg: RecordSchema) => {
		emits('change', arg)
	}
</script>

<template>
	<div>
		<ui-data-table :columns="recordColumn ?? healthColumns" :loading="isLoading" :records :options="tableOptions">
			<template #bodyCell="{ column, record, index }">
				<!--				<span v-if="column?.dataIndex === 'sn'">{{ index }}</span> -->
				<span v-if="column?.dataIndex === 'full_name'">
					{{ record?.first_name ?? record?.meta?.first_name }}
					{{ record?.last_name ?? record?.meta?.last_name }}
				</span>
				<span v-if="column?.dataIndex === 'first_name'">
					{{ record?.first_name ?? record?.meta?.first_name }}
				</span>
				<span v-if="column?.dataIndex === 'last_name'">
					{{ record?.last_name ?? record?.meta?.last_name }}
				</span>
				<span v-if="column?.dataIndex === 'email'">
					{{ record?.email ?? record?.meta?.email }}
				</span>
				<span v-if="column?.dataIndex === 'phone_number'">
					{{ record?.phone_number ?? record?.meta?.phone_number }}
				</span>
				<span v-if="column?.dataIndex === 'dependants'">
					{{ record?.meta?.no_of_dependant || record?.no_of_dependant || 0 }}
				</span>
				<my-cover-plan-status
					v-else-if="column?.key === 'status'"
					:pending="!record?.policy_number"
					:plan-details="record || null"
				/>
				<slot :name="column?.dataIndex" :record="record" :index="index" />
				<button
					v-if="column?.dataIndex === 'details'"
					type="button"
					aria-label="activate staff"
					aria-roledescription="view beneficiary plan details"
					class="text-sm font-medium"
					@click="getStaff(record)"
				>
					<span class="font-medium text-primary-2"> {{ actionBtnText || 'Activate' }} </span>
				</button>
			</template>
		</ui-data-table>
	</div>
</template>
